import React from 'react'
import { Button, DialogOverlay, DialogOverlayActions, Image, usePageWidth } from '@fs/zion-ui'
import { Trans, useTranslation } from 'react-i18next'
import skipImageIllustration from './images/skipimage.svg'

export default function SkipImageOverlay({ overlay, handleClickNewImage }) {
  const [t] = useTranslation()
  const pageWidth = usePageWidth()
  const isMobile = pageWidth({ default: true, md: false })

  return (
    <DialogOverlay
      {...overlay}
      title={t('task-viewer.skip-image-overlay.heading', 'Do you want to skip the image?')}
      nonClosable
      footer={
        <DialogOverlayActions>
          <Button
            data-testid="stay-here-button"
            onClick={overlay.close}
            emphasis="low"
            linkName="Skip Image Overlay Stay Here Button"
            title={t('tasks-done-overlay.skip-image-overlay.stay-button', 'STAY HERE')}
          >
            {t('tasks-done-overlay.skip-image-overlay.stay-button', 'STAY HERE')}
          </Button>
          <Button
            data-testid="new-image-button"
            onClick={handleClickNewImage}
            emphasis="high"
            linkName="Skip Image Overlay New Image Button"
            title={t('tasks-done-overlay.skip-image-overlay.new-image-button', 'NEW IMAGE')}
          >
            {t('tasks-done-overlay.skip-image-overlay.new-image-button', 'NEW IMAGE')}
          </Button>
        </DialogOverlayActions>
      }
    >
      <Image
        src={skipImageIllustration}
        alt=""
        maxWidth={isMobile ? '100%' : '482px'}
        height={isMobile ? '150px' : '200px'}
        positionY="middle"
        positionX="center"
      />
      <Trans i18nKey="tasks-done-overlay.skip-image-overlay.message">
        Looks like you skipped a lot of names in a row. Would you like to try a new image?
      </Trans>
    </DialogOverlay>
  )
}
